module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('a', {
    attrs: {
      "id": "title6"
    }
  }, [_c('h1', {
    staticClass: "title-frontMatter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Biltcliffe – Photographers")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_net"
  }, [_c('div', {
    staticClass: "image_net"
  }, [_c('img', {
    attrs: {
      "alt": "e9781783408566_i0006.jpg",
      "src": "images/e9781783408566_i0006.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Joshua Biltcliffe c.1852 – 1937. (L. Robinson collection).")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Joshua Biltcliffe was born around 1852 in Penistone and can be found in the 1881 census returns for the parish living at Prospect Terrace, Thurlstone. Here with his wife, Mary, they raised a family which at this time consisted of three boys, Ernest, John Thomas and Henry. At least one further child, another son, Fred, was born after this. Joshua worked as a steelworks labourer but had other ambitions for his more creative talents. He founded a photographic shop in a small hut at the Prospect, which prospered and so facilitated a move to grander premises on Bridge Street in Penistone. To supplement his income from photography Joshua also sold violin strings, gramophones and hosiery but it was his studio, which gained him the most notoriety. Later he added a picture frame workshop and dark room. Subsequently, further shops were opened in Skelmanthorpe and Denby Dale and he was joined in the family business by two of his sons, John Thomas and Fred, who, after their fathers death in 1937 aged 85, respectively took over the shops in Penistone and Skelmanthorpe. Joshua Biltcliffe’s name was placed on the Roll of Honour at the Memorial Hall, London, by the Congregational Union of England and Wales in June 1937. He had a lifelong connection with Netherfield Church, Penistone – being christened there in 1854, he also held the following offices: Superintendent and Teacher, 1874 – 1917, Church Member and Deacon since 1886, Church Secretary, 1886 – 1910, Member of the Choir, 1864-1904, Communion Fund Treasurer, 1918 – 1937 and Pew Steward, 1889 – 1915.")]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Advertisement taken from the Penistone Almanac. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("L. Robinson collection")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "image_text"
  }, [_c('img', {
    attrs: {
      "alt": "e9781783408566_i0007.jpg",
      "src": "images/e9781783408566_i0007.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781783408566_i0008.jpg",
      "src": "images/e9781783408566_i0008.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("John Thomas Biltcliffe c.1880 – 1964. (L. Robinson collection).")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781783408566_i0009.jpg",
      "src": "images/e9781783408566_i0009.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Frederick Jubb Biltcliffe 1899 – 1959. (S. Sheead collection).")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Fred Biltcliffe’s studio in Skelmanthorpe. (S. Sheead collection).")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781783408566_i0010.jpg",
      "src": "images/e9781783408566_i0010.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_vm._v("Joshua was far sighted and recorded every class at Penistone Grammar school for generations. His son, John Thomas, carried on the task recording the pupils, along with his father for a period of around 80 years and Fred made his own mark in and around Skelmanthorpe. Indeed the family recorded so many facets of a now bygone age and their photographs adorn many modern day local history books. They rarely get the credit they deserve for their selfless and farsighted historical preservation. That is not to say that all the photographs in this volume are by their hands, but it would be remiss in the extreme not to pay some kind of recognition to a name which in the Denby and Penistone districts had become synonymous with crystal quality pictures from a time that is now lost but for their work. Their deaths, John Thomas in 1964 aged 84 and Fred in 1959 aged 60 saw the end of both businesses but their names live on through their work.")]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_vm._v("Most old photographs do not bear a date, we are lucky when one does. In some cases an approximation can be made, but rather than guess at dates to within a decade I have opted to only give them when a date is shown on the original or when they can reasonably be worked out. Many individuals will be able to date some of the photographs, but across this book and its companion volume there are over 800 photographs and sheer logistics currently prevent any further in depth analysis. As a guide to readers, the vast majority of the photographs within these pages date from around 1890 to the beginning of the Second World War, after all – this is an archive photograph album!")]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Every care has been taken to establish the names of the original copyright holders for the photographs featured within this book and to gain their permission for their use. The author and publishers would like to apologise in advance for any omissions, which will, of course, be credited in any subsequent reprint of this work.")]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781783408566_i0011.jpg",
      "src": "images/e9781783408566_i0011.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("This postcard bears the following statement: ‘Ruth E Storer – The Girl Preacher – Denby’. I would be grateful for any information regarding this young lady and her preaching career. Please contact me via the publishers")]), _vm._v(". "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(G. Knowles collection)")]), _vm._v(".")])])])])]), _c('a', {
    attrs: {
      "id": "title6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f960f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783408566_fm03.vue
// module id = 81
// module chunks = 0